import { gql } from '@/__generated__';

export const GET_USER_MODAL_TITLE = gql(`#graphql
  query UserConfiguration_GetModalTitle($userId: Int!) {
    user(input: { id: $userId }) {
      id
      fullName
      email
    }
  }
`);
